import 'slick-carousel/slick/slick';

const heroCarousel = {
    heroCarousels: $('.js-hero-slider'),
    $dots: undefined,
    $dotsButtons: undefined,
    buildCarousel(carousel) {
        const $carousel = $(carousel);
        if ($carousel.find('.c-hero-slide').length === 1) {
            return;
        }
        if (!$carousel.hasClass('c-hero-slider--not-ready')) {
            console.debug('hero slider already initialized');
            return;
        }
        const autoSlideSeconds = $carousel.data('autoSlideSeconds');
        const i18nArrowLeft = $carousel.data('i18nArrowLeft');
        const i18nArrowRight = $carousel.data('i18nArrowRight');
        const autoPlay = Boolean(autoSlideSeconds);
        const autoPlaySpeed = autoPlay ? parseInt(autoSlideSeconds, 10) * 1000 : 3000;

        $carousel
            .removeClass('c-hero-slider--not-ready')
            .on('init', (event, slick) => {
                this.$dots = $carousel.find('.slick-dots');
                this.$dotsButtons = this.$dots.find('button');
                this.adjustDotsColor(slick.$slides[0]);
            })
            .on('afterChange', (event, slick, currentSlide) => {
                this.adjustDotsColor(slick.$slides[currentSlide]);
            })
            .on('breakpoint', (event, slick, currentSlide) => {
                this.$dots = $carousel.find('.slick-dots');
                this.$dotsButtons = this.$dots.find('button');
                this.adjustDotsColor(slick.$slides[currentSlide]);
            })
            .slick({
                arrows: true,
                prevArrow: `
                    <button class="c-hero-slider__arrow c-hero-slider__arrow--left btn-reset" aria-label="${i18nArrowLeft}">
                        <svg class="icon c-hero-slider__icon">
                            <use xlink:href="#icon-hero-slider-arrow-left"></use>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button class="c-hero-slider__arrow c-hero-slider__arrow--right btn-reset" aria-label="${i18nArrowRight}">
                        <svg class="icon c-hero-slider__icon">
                            <use xlink:href="#icon-hero-slider-arrow-right"></use>
                        </svg>
                    </button>
                `,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                autoplay: autoPlay,
                autoplaySpeed: autoPlaySpeed,
                speed: 500,
                dots: true,
                rows: 0,
                lazyLoad: 'ondemand',
                adaptiveHeight: true,
                pauseOnFocus: true,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            pauseOnFocus: false
                        }
                    }
                ]
            });
    },
    adjustDotsColor(activeSlide) {
        const style = window.getComputedStyle(activeSlide);
        const buttonColor = style.getPropertyValue('--button-color');
        const buttonBgColor = style.getPropertyValue('--button-bg-color');

        console.log('buttonColor: ', buttonColor);
        console.log('buttonBgColor: ', buttonBgColor);

        if (buttonBgColor) {
            this.$dotsButtons.css('background-color', buttonBgColor);
        } else {
            this.$dotsButtons.css('background-color', '');
        }

        if (buttonColor) {
            this.$dots.find('.slick-active button').css('color', buttonColor);
        } else {
            this.$dots.find('.slick-active button').css('color', '#000000');
        }
    },
    recalculate(carousel) {
        $(carousel).slick('setPosition');
    },
    buildCarousels() {
        this.heroCarousels.each((index, element) => {
            this.buildCarousel(element);
        });
    },
};

window.heroCarousel = heroCarousel;
